import { DependencyType } from '../api/types';

export interface PredecessorEntry {
  number: number;
  type: DependencyType;
  lagDays: number;
}

const TOKEN = /^(\d+)(DF|FF|FD|DD)([+-]\d+)?$/i;

export function parsePredecessorsText(text: string): PredecessorEntry[] {
  return text
    .split(';')
    .map((s) => s.trim())
    .filter(Boolean)
    .map((token) => {
      const m = token.match(TOKEN);
      if (!m) return null;
      return {
        number: parseInt(m[1], 10),
        type: m[2].toUpperCase() as DependencyType,
        lagDays: m[3] ? parseInt(m[3], 10) : 0,
      };
    })
    .filter((e): e is PredecessorEntry => e !== null);
}

export function formatPredecessorsText(entries: PredecessorEntry[]): string {
  return entries
    .map((e) => `${e.number}${e.type}${e.lagDays > 0 ? `+${e.lagDays}` : e.lagDays < 0 ? e.lagDays : ''}`)
    .join(';');
}
